import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import {Service} from "angular-ecmascript/module-helpers";

class TimeoutConfigInterceptor extends Service {
    static $name = 'TimeoutConfigInterceptor';

    request(config) {
        config.timeout = 30 * 1000;
        return config;
    }
}

let TimeoutConfigInterceptorModule = Angular.module('TimeoutConfigInterceptor', []);

new Loader(TimeoutConfigInterceptorModule)
    .load(TimeoutConfigInterceptor);

export default TimeoutConfigInterceptorModule;



// WEBPACK FOOTER //
// ./src/modules/main/interceptors/timeoutConfig.interceptor.js